import { Dispatch } from 'redux';

import { Events } from 'src/constants/webSocketConsts/events';
import { customFieldsApi } from 'src/services/api/customFieldsApi';
import {
  CustomFieldEntity,
  CustomFieldEntityType,
} from 'src/store/clients/types';
import { ensureUnreachable } from 'src/utils/common_utils';

export interface CustomFieldWSEntity extends CustomFieldEntity {
  fields: {
    addedCustomFields?: string[];
    deletedCustomFields?: string[];
  };
}

const updateCache = (
  event: Events,
  items: CustomFieldWSEntity[],
  draft?: CustomFieldEntity,
) => {
  console.info('updateCache', { draft, event, items });
  const [customFieldItem] = items;

  if (!draft) {
    return;
  }

  switch (event) {
    case Events.Insert:
    case Events.Modify:
    case Events.Remove:
      Object.assign(draft, customFieldItem);
      break;
    case Events.Refresh:
    case Events.DomainVerified:
      return;
    default:
      ensureUnreachable(event);
  }
};

export function handleCustomFieldsUpdate(
  event: Events,
  items: CustomFieldWSEntity[],
  dispatch: Dispatch<any>,
  entityType: CustomFieldEntityType = CustomFieldEntityType.CLIENT,
) {
  const customFieldItem = items.at(0);
  if (!customFieldItem) {
    console.warn('customFieldItem is undefined');
    return;
  }

  // Handle both client and company custom fields
  dispatch(
    customFieldsApi.util.updateQueryData(
      'getCustomFields',
      { type: entityType },
      (draft?: CustomFieldEntity) => {
        updateCache(event, items, draft);
      },
    ),
  );
}
